import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const MacOSIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M5.927 5.07771C6.25103 3.64647 6.70814 2.14928 7.10185 1H5.8C4.11984 1 3.27976 1 2.63803 1.32698C2.07354 1.6146 1.6146 2.07354 1.32698 2.63803C1 3.27976 1 4.11984 1 5.8V10.2C1 11.8802 1 12.7202 1.32698 13.362C1.6146 13.9265 2.07354 14.3854 2.63803 14.673C3.27976 15 4.11984 15 5.8 15H8.23348C8.05797 14.4999 7.92895 13.9859 7.83649 13.4773C6.85272 13.385 5.86677 13.0177 4.45775 12.4511C4.09107 12.3036 3.90705 11.8703 4.04674 11.4832C4.18643 11.0961 4.59693 10.9019 4.96362 11.0493C6.21027 11.5507 6.98759 11.8324 7.65626 11.9437C7.61599 11.2498 7.63148 10.6094 7.67212 10.0822H6.45827C6.17904 10.0822 5.92293 9.92703 5.79359 9.67956C5.49851 9.115 5.46997 8.34079 5.51968 7.61261C5.57213 6.8443 5.72657 5.96298 5.927 5.07771ZM2.5 4.75C2.5 4.33579 2.83579 4 3.25 4C3.66421 4 4 4.33579 4 4.75V6.25C4 6.66421 3.66421 7 3.25 7C2.83579 7 2.5 6.66421 2.5 6.25V4.75Z"
		></path>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M9.34991 13.4053C10.2134 13.2541 11.1907 12.9273 12.514 12.4617C12.8862 12.3307 13.0874 11.906 12.9633 11.513C12.8393 11.1201 12.4369 10.9077 12.0646 11.0387C10.7246 11.5102 9.85587 11.7919 9.1575 11.9191C9.09272 10.8946 9.1643 9.98584 9.25469 9.45896C9.29207 9.24106 9.2314 9.01776 9.0889 8.84873C8.94639 8.6797 8.73657 8.58215 8.51548 8.58215H7.02259C6.99784 8.36936 6.99105 8.08312 7.01619 7.71477C7.06125 7.05478 7.19793 6.25717 7.38997 5.40893C7.74744 3.82997 8.27961 2.14931 8.69105 1H10.2C11.8802 1 12.7202 1 13.362 1.32698C13.9265 1.6146 14.3854 2.07354 14.673 2.63803C15 3.27976 15 4.11984 15 5.8V10.2C15 11.8802 15 12.7202 14.673 13.362C14.3854 13.9265 13.9265 14.3854 13.362 14.673C12.7202 15 11.8802 15 10.2 15H9.84526C9.62058 14.4939 9.46059 13.9507 9.34991 13.4053ZM12.25 4C11.8358 4 11.5 4.33579 11.5 4.75V6.25C11.5 6.66421 11.8358 7 12.25 7C12.6642 7 13 6.66421 13 6.25V4.75C13 4.33579 12.6642 4 12.25 4Z"
		></path>
	</svg>
))
